import { PurchaseOrder } from "../../../models/purchase.order";

export interface SearchAttribute {
  attribute: string;
  values: string[];
}

export enum PurchaserOrderFrom {
  BOOKING = "booking",
  SHIPMENT = "shipment",
}

export enum PurchaseOrderSearch {
  SUPPLIER_NAME = "supplier.name",
  CONSIGNEE_FULLNAME = "consignee.fullName",
  CONSIGNEE_NAME = "consignee.name",
}
interface PurchaseOrderToSearch extends PurchaseOrder {
  [x: string]: any;
}

const modifyAttributeProperty = (searchAttribute: string) => {
  if (searchAttribute === "purchase_order_id") return "reference";

  return searchAttribute;
};

export const filterPurchaseOrders = (
  purchaseOrders: PurchaseOrder[],
  searchAttributes: SearchAttribute[]
) => {
  return searchAttributes.reduce((filteredOrders, searchAttribute) => {
    const { attribute, values } = searchAttribute;

    if (attribute.includes(".")) {
      const [objectName, objectProperty] = attribute.split(".");

      return filteredOrders.filter((purchaseOrder: PurchaseOrderToSearch) => {
        return values.some((value) => {
          const nestedObject = purchaseOrder?.[objectName];

          return String(nestedObject?.[objectProperty])
            ?.toLowerCase()
            .includes(value.toLowerCase());
        });
      });
    }

    return filteredOrders.filter((purchaseOrder: PurchaseOrderToSearch) => {
      return values.some((value) =>
        String(purchaseOrder[modifyAttributeProperty(attribute)])
          ?.toLowerCase()
          .includes(value.toLowerCase())
      );
    });
  }, purchaseOrders);
};
